"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.translationsNamespace = exports.defaultTranslations = void 0;
/* istanbul ignore file @preserve */ /**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */ const defaultTranslations = exports.defaultTranslations = {
    basket: 'Basket',
    billingAddress: 'Billing address',
    cardConsentIsRequired: 'Card consent is required. Please review your order.',
    checkout: 'Checkout',
    continueClickIsRequired: 'Please select "Continue" on the delivery step to proceed with your order.',
    deliveryChannelIsMissing: 'Delivery channel is missing. Please review your order.',
    edit: 'Edit',
    goToYourProfileSettings: 'Go to your profile settings',
    items: 'item(s)',
    loading: 'Loading',
    mandatoryBillingAddressMissing: 'Billing address is missing. Please review your order.',
    mandatoryEmailMissing: 'Email address is missing. Please review your order.',
    mandatoryPhoneMissing: 'Phone number is missing. Please review your order.',
    myInformation: 'My information',
    needToMakeAChange: 'Need to make a change?',
    noBasketItemsFound: 'No basket items found',
    offers: 'Offers',
    orderIsPlacedAlready: 'Order is placed already',
    payment: 'Payment',
    paymentProviderIsMissing: 'Payment provider is missing. Please review your order.',
    recurringPaymentConsentIsRequired: 'Recurring payment consent is required',
    yourEmailAddressIsMissing: 'Your email address is missing.',
    yourPhoneNumberIsMissing: 'Your phone number is missing.'
};
const translationsNamespace = exports.translationsNamespace = 'checkout';
